'use client';

import React from 'react';
import { Search } from 'lucide-react';
import { useFilters } from '@/context/FiltersContext';

export const SearchFilter: React.FC = () => {
  const { filters, updateFilter } = useFilters();

  return (
    <div className="relative">
      <Search size={11} className="absolute left-[8px] top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
      <input
        type="text"
        value={filters.searchQuery}
        onChange={(e): void => updateFilter('searchQuery', e.target.value)}
        placeholder="Search startups…"
        aria-label="Search startups"
        className="w-full bg-bg-raised border border-border text-text-secondary text-[11px] pl-[24px] pr-[8px] py-[5px] rounded-sm placeholder:text-text-muted focus:outline-none focus:border-border-mid tracking-[0.02em]"
      />
    </div>
  );
};
